import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Recommendationsv6 } from '../models/recommendations.v6';
import { RemoteConfigService } from './remote-config.service';

const DEFAULT_RECOMMENDATIONS_VERSION = '11';

@Injectable({
    providedIn: 'root'
})
export class RecommendationsService {

    /** Recommendations API version from remote config (recommendations_version), mirroring the web app. */
    get apiVersion(): string {
        return 'v' + (this.config.remoteConfig?.recommendations_version || DEFAULT_RECOMMENDATIONS_VERSION);
    }

    constructor(
        private envService: EnvironmentService,
        private config: RemoteConfigService,
        private http: HttpClient) {
    }

    getUpNext(mediaId: number, seasonId: number = undefined, count: number = 20, recommendationId: string = undefined): Observable<Recommendationsv6> {
        let params = new HttpParams()
            .set('count', JSON.stringify(count));

        if (recommendationId) {
            params = params.set('recommendationId', recommendationId);
        }

        if (seasonId) {
            params = params.set('seasonId', JSON.stringify(seasonId));
        }

        return this.http.get<Recommendationsv6>(`${this.envService.contentHost}/${this.apiVersion}/recommendations/up-next/${mediaId}`, { params });
    }

    getRecommendationsV8(page: number = 1, recommendationId: string = undefined): Observable<Recommendationsv6> {
        let params = new HttpParams()
            .set('page', JSON.stringify(page));

        if (recommendationId) {
            params = params.set('recommendationId', recommendationId);
        }

        return this.http.get<Recommendationsv6>(`${this.envService.contentHost}/${this.apiVersion}/recommendations`, { params });
    }

    getRecommendedForYou(page = 1) {
        let params = new HttpParams()
            .set('page', JSON.stringify(page));

        return this.http.get<Recommendationsv6>(`${this.envService.contentHost}/${this.apiVersion}/recommendations/recommended-for-you`, { params });
    }

    getPopular(page = 1) {
        let params = new HttpParams()
            .set('page', JSON.stringify(page));

        return this.http.get<Recommendationsv6>(`${this.envService.contentHost}/${this.apiVersion}/recommendations/popular`, { params });
    }
}
